module.exports = __webpack_public_path__ + "media/10.4312c65f.mp3";